export default "__VITE_ASSET__29c7a8f9__"